import React from "react";

// import FwSelfieCamera from "../components/FwSelfieCamera";
import FwSelfieCamera from "../../pages/FwSelfieCamera";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"

const SelfieCapturePage = ({
  selfieCameraRef,

  selfieFaceReady,
  setSelfieFaceReady,

  selfieHint,
  setSelfieHint,

  selfieError,
  setSelfieError,

  selfiePhoto,
  setSelfiePhoto,

  leadSubmitting,

  persistSelfie,
  submitLeadAndContinue,

  setScreen,
}) => {
  return (
    <section className="fw-screen fw-screen--selfie fw-fade">
           <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>
      <h1 className="fw-title">
        Take a Selfie
      </h1>

      <div className="fw-selfie-capture">
        <FwSelfieCamera
          ref={selfieCameraRef}
          active={true}
          onReadyChange={setSelfieFaceReady}
          onHintChange={setSelfieHint}
          onError={setSelfieError}
        />

        <p className="fw-selfie-capture__hint">
          {selfieHint}
        </p>

        {selfieError && (
          <p className="fw-error">
            {selfieError}
          </p>
        )}
      </div>

      <div className="fw-selfie-safe">
        <strong>
          100% Safe and Secure
        </strong>

        <p>
          The data share will be encrypted,
          stored securely, and only used to
          verify your identity.
        </p>
      </div>

      <div className="fw-actions">
        <button
          type="button"
          className="fw-btn fw-btn--ghost"
          onClick={() =>
            setScreen("/apply-new/selfieIntro")
          }
        >
          Back
        </button>

        <button
          type="button"
          className="fw-btn fw-btn--primary"
          disabled={
            !selfieFaceReady ||
            leadSubmitting
          }
          onClick={() => {
            const photo =
              selfieCameraRef.current
                ?.capturePhoto?.() || "";

            if (!photo) {
              setSelfieError(
                "Could not capture selfie. Please try again."
              );
              return;
            }

            setSelfiePhoto(photo);

            persistSelfie(photo);

            submitLeadAndContinue(photo);
          }}
        >
          Proceed
        </button>
      </div>
    </section>
  );
};

export default SelfieCapturePage;